// Constants
import { GA } from '@/app/constants/ga-constants';

// Mixins
import { GoogleAnalyticsMixins } from '@/app/mixins/utils/google-analytics-mixins';

export default {
    name: 'LandingPagePlans',
    mixins: [GoogleAnalyticsMixins],
    data() {
        return {
            isMultipleColumns: true,
            plans: [
                {
                    amount: 7,
                    title: 'Tracking And Health Data',
                    buttonClass: 'btn-primary'
                },
                {
                    amount: 16,
                    title: 'Flea, Tick & Worm',
                    buttonClass: 'btn-primary'
                },
                {
                    amount: 22,
                    title: 'Bundle',
                    buttonClass: 'btn-warning'
                }
            ]
        }
    },
    created() {
        this.isMultipleColumns = window.innerWidth >= 992;
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.isMultipleColumns = window.innerWidth >= 992;
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', () => {
            this.isMultipleColumns = window.innerWidth >= 992;
        });
    },
    methods: {
        sendLearnMorePlansAnalytics() {
            this.sendEventTrackingToGA(GA.LANDING_PAGE.PLANS_LEARN_MORE_BUTTON.ACTION, GA.LANDING_PAGE.CATEGORY, GA.LANDING_PAGE.PLANS_LEARN_MORE_BUTTON.LABEL);
        }
    }
}